<template lang="pug">
div
  v-row(v-if="!$loader.isLoading")
    v-col(
      cols="12" v-if="$route.name === 'EducationCourseUnitList' || !isMobile"
    ).pb-0
      .d-flex.align-center
        v-col(cols="auto").mr-4.pl-0.pb-0
          v-icon.mr-2(color="black" size="24") mdi-image-filter-none
          span {{ $tc('units', course.course_units_count) }}
        v-col(cols="auto").pb-0
          v-icon.mr-2(color="black" size="24") mdi-clock-outline
          span {{ $tc('hours', course.duration) }}
        v-col.text-end.pb-0
          v-icon(color="primary" size="28" @click="openInfoModal") mdi-help-circle-outline

    v-col(cols=12 md=8 lg=8 xl=9 order=1).relative

      v-overlay.align-start.pt-8(
        v-if="course.contract && !course.contract.isMyEnrollment"
        absolute
        :value="!course.contract.userViewContract"
      )
        v-card(light).sdo-card.mx-4
          v-card-title Ознакомьтесь с договором
          v-card-text
            v-card.sdo-card.overflow-auto(max-height=500 )
              v-card-text(v-html="course.contract.listener_preview_document")
              div.py-2(v-intersect="onIntersect")
          v-card-actions
            v-btn(
              color="primary"
              :disabled='!isIntersect' block
              @click="course.contract.viewContract()"
            ) Ознакомлен с договором

      portal-target(
        v-if="$route.name !== 'EducationCourseUnitList' || !isMobile"
        name="course-title"
      )
      router-view(
        :course="course"
      )

    v-col(
      v-if="$route.name === 'EducationCourseUnitList' || !isMobile"
      cols=12 md=4 lg=4 xl=3 :order="isMobile ? '-1' : '2'"
      :class="{ 'pl-4': !isMobile}"
    )
      v-img.mb-4(
        :lazy-src="require('@/assets/course-sample.png')"
        :src="course.image ? course.image.url : require('@/assets/course-sample.png')"
        height="160"
        gradient="to top, rgba(0, 0, 0, 0.4) 0%, transparent 72px"
      ).sdo-radius

      portal-target(
        v-if="isMobile"
        name="course-title"
      )

      //- record-status-wrap(
      //-   :user-record="course.priority_user_prior_record.user_record"
      //-   v-slot:default="{ color, label, group }"
      //- )
      //-   v-alert(flat :color="color" text outlined).mb-2.pa-4.sdo-radius
      //-     .text-body-2
      //-       .d-flex.align-center
      //-         .pb-2
      //-           strong.mr-2 Статус:
      //-           span {{ label }}
      //-         v-icon.ml-auto(
      //-           color="primary"  @click="openInfoModal"
      //-         ) mdi-help-circle-outline
      //-       .pb-2
      //-         strong.mr-2 Группа:
      //-         span {{ group.short_name || 'Не назначена' }}
      //-       .pb-0
      //-         strong.mr-2 Срок завершения:
      //-         span {{ course.priority_user_prior_record.end_learning | dp('d MMMM y') }}
      v-btn.mb-4(
        v-if="course.contract"
        depressed outlined
        color="primary" block
        @click="routeContract(course)"
      ).d-flex
        v-spacer
        span Открыть договор
        v-spacer
        v-icon.ml-auto(right ) mdi-chevron-right

          //- v-list-item-action.my-0: v-icon(color="primary") mdi-arrow-right

      //- component(
      //-   v-if="course"
      //-   :course="course"
      //-   :enrollment="course.priority_user_prior_record"
      //-   :is="educationStatusComponent"
      //- ).mb-6

      user-record(
        v-if="userRecord && userRecord.group"
        :group="userRecord.group"
        :course="course"
      )

      course-translation.mt-4(
        :group="userRecord.group"
        :course="course"
      )

      record-status-wrap(
        :user-record="userRecord"
        v-slot:default="{ status }"
      )
        template(v-if="status === $conf.ATTESTATION_STATUSES.attestated")
          v-alert.mt-8(
            v-if="!course.attributes_filled"
            color="error"
            text
            outlined
          ).sdo-radius.mb-6
            h3.mb-2 Заполните данные!
            p По всей видимости заполненные вами данные при зачислении были указаны неверно.
            p Пожалуйста, укажите корректные данные.
            p В ином случае информация о прохождении вами курса может быть не принята
              |  федеральными реестрами учета выданных документов.
            v-row.ma-0.mt-2
              v-btn(
                depressed
                color="error"
                :to=`{
                  name: 'UserRecordCourse',
                  params: { courseId: course.id },
                }`
              ) Заполнить
        v-expand-transition(v-else)
          v-alert.mt-8(
            v-if="!course.attributes_filled"
            color="warning"
            text
            outlined
          ).sdo-radius.mb-6
            h3.mb-2 Заполните данные
            p(
              v-if="!course.user_group_id"
            ) Внимание! Для принятия решения о зачислении внесите всю необходимую информацию
            div(
              :class="{ 'pb-2': !isMobile }"
            ) Пожалуйста, предоставьте необходимую  информацию для решения
              |  бюрократических вопросов
            v-row.ma-0.mt-2
              v-btn(
                depressed
                color="warning"
                :to=`{
                  name: 'UserRecordCourse',
                  params: { courseId: course.id },
                }`
              ) Заполнить

      contract-alert.mb-0(
        v-if="course.contract && contractAlertView"
        :contract="course.contract"
        :course="course"
      )
  portal(
    v-if="$route.name === 'EducationCourseUnitList' && !$loader.isLoading"
    to="course-title"
  )
    h3.text-h6.my-1.mb-6 {{ course.title }}
    //- v-expansion-panels(outlined flat focusable).mb-4.mx-n2
    //-   v-expansion-panel
    //-     v-expansion-panel-header.primary--text.d-inline.px-2
    //-       span.pl-2
    //-         span.text-body-2.mb-2: strong Описание курса
    //-       template(v-slot:actions)
    //-         .pt-1
    //-           v-icon.ml-2(color="primary" size="18")  $expand

    //-     v-expansion-panel-content.text-body-1.pl-2
    //-       .pre-wrap {{ course.description }}
</template>

<script>
import RecordStatusWrap from '@/components/Enrollment/RecordStatusWrap.vue';
import PreviewContract from '@/modules/PaymentSystem/components/PreviewContract.vue';

import UnitCard from '../../components/UnitCard.vue';
import StudentEnrollWait from '../../components/StatusAlerts/StudentEnrollWait.vue';
// import StudentEnrollRefused from '../components/StatusAlerts/StudentEnrollRefused.vue';
import StudentEnrolled from '../../components/StatusAlerts/StudentEnrolled.vue';
import StudentAllowedAttestation from '../../components/StatusAlerts/StudentAllowedAttestation.vue';
import StudentAttestated from '../../components/StatusAlerts/StudentAttestated.vue';
import StudentRefusedAttestation from '../../components/StatusAlerts/StudentRefusedAttestation.vue';
import StudentExcluded from '../../components/StatusAlerts/StudentExcluded.vue';
import CourseTranslation from '../../components/CourseTranslation.vue';
import UserRecord from '../../components/UserRecord.vue';
import ContractAlert from '../../components/ContractAlert.vue';

export default {
  name: 'CourseUnitList',
  components: {
    UnitCard,
    UserRecord,
    ContractAlert,
    CourseTranslation,
    RecordStatusWrap,
  },
  data() {
    return {
      overlay: false,
      isIntersect: false,
      courseUnits: [],
      courseTasks: [],
      course: null,
      selectedUnit: null,
    };
  },
  provide() {
    return {
      course: this.course,
    };
  },
  computed: {
    viewContractPreview() {
      const { contract } = this.course;
      return contract && !contract.isMyEnrollment && contract.is_concluded;
    },
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
    courseId() {
      return this.$route.params.courseId;
    },
    educationStatusComponent() {
      const BY_ATTESTATION_STATUS = {
        [this.$conf.ATTESTATION_STATUSES.enrolled]: StudentEnrolled,
        [this.$conf.ATTESTATION_STATUSES.allowedAttestation]: StudentAllowedAttestation,
        [this.$conf.ATTESTATION_STATUSES.attestated]: StudentAttestated,
        [this.$conf.ATTESTATION_STATUSES.refusedAttestation]: StudentRefusedAttestation,
        [this.$conf.ATTESTATION_STATUSES.excluded]: StudentExcluded,
      };
      return BY_ATTESTATION_STATUS[this.course.prior_record_status] || StudentEnrollWait;
    },
    userRecord() {
      return this.course?.priority_user_prior_record?.user_record;
    },
    contractAlertView() {
      const { contract } = this.course;
      if (this.$user.data.id !== contract?.owner_id && contract && contract?.isPaymentPrePayment) {
        return false;
      }
      return contract && !contract?.isAllPayed;
    },
  },

  async created() {
    this.$loader.start();
    await this.fetchCourse();
    this.$loader.stop();
  },
  methods: {
    openInfoModal() {
      this.$modals.show('empty-controller', {
        component: this.educationStatusComponent,
        componentProps: {
          enrollment: this.course.priority_user_prior_record,
          course: this.course,
        },
      });
    },
    routeContract(item) {
      if (item.contract.owner_id === this.$user.data.id) {
        this.$router.push({
          name: 'ContractView',
          params: { id: item.contract.id },
          query: { courseId: item.id },
        });
      } else {
        this.$modals.show('generic-controller', {
          component: PreviewContract,
          title: 'Договор',
          dialogProps: {
            width: 800,
          },
          'component-props': {
            previewDocument: item.contract.listener_preview_document,
          },
        });
      }
    },
    openPreviewDocument() {

    },
    onIntersect(entries) {
      if (entries[0].isIntersecting) {
        this.isIntersect = true;
      }
    },
    async fetchCourse() {
      const { item } = await this.$api.courses.show(this.courseId, {
        expand: 'prior_record_status,priority_user_prior_record,chat_room,contract,tasks,course_units_count,telegram',
      }, this.$conf.COURSE_SERVICE.student);
      this.course = item;

      const { tasks } = item;

      const promises = tasks.map(async (task) => {
        const params = {
          'search[task_id]': task.id,
          'search[user_id]': this.$user.data.id,
          sort: '-id',
          'per-page': 200,
        };
        const { data } = await this.$api.journal.getJoarnalAnswer({ params });
        let journals = data.data;
        if (journals.some(({ status }) => status === 2)) {
          const taskParams = {
            'search[task_id]': task.id,
            'search[user_id]': this.$user.data.id,
          };
          const taskResponse = await this.$api.journal.getJournalTasks({ params: taskParams });
          journals = journals.reduce((acc, cur) => {
            const { status } = taskResponse.data.data
              .find((i) => cur.id === i.journal_answer_id) || { status: 6 };
            return [...acc, { ...cur, status }];
          }, []);
        } else {
          journals = journals.map((journal) => ({ ...journal, status: 7 }));
        }
        return {
          task,
          journals,
        };
      });
      const res = await Promise.all(promises);
      this.course.tasks = res.map(({ task, journals }) => ({
        ...task,
        user_attempts: journals.length,
        status: journals.length ? journals[0].status : 5,
      }));

      item.checkAttributes();
      item.fetchUnread({ topConsultation: true, userId: this.$user.data.id });
      item.fetchContract(this.$user.data.id);
    },
    viewContract() {
      this.course.contract.view_contract = true;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-expansion-panel-header {
  padding: 0 !important;
  min-height: 40px !important;
}
::v-deep .v-expansion-panel-header--active::before {
  opacity: 0 !important;
}
::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>
